export default {
  tabs: [
    {
      // 门店定价 -》 详情 -》复制/分享
      name: 'CarDetailShare',
      path: '/carDetailShare',
      component: () => import('./src/CarDetail.vue'),
      meta: {
        title: '车辆详情',
      },
    },
  ],
}
